import './polyfills';
import { routeApiThroughDevServer } from './devApiProxy';
import { AppRegistry } from 'react-native';
import { authReady } from './shims/firebaseAuth';
import { fitStandaloneViewport } from './standaloneViewport';
import App from '../App';
import { name as appName } from '../app.json';

if (__API_PROXY__) routeApiThroughDevServer(import.meta.env.API_BASE_URL);
fitStandaloneViewport();

AppRegistry.registerComponent(appName, () => App);
authReady.finally(() => {
  AppRegistry.runApplication(appName, { rootTag: document.getElementById('root') });
});
